// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"408b574f","234":"1499b3bc","260":"30cf7e5f","268":"78e1f1c1","437":"47a215e0","473":"3e739ff0","640":"e606ca96","645":"c27a552f","681":"cb5e821b","705":"7f4ebdb7","706":"e43f4be1","741":"3d5c4955","904":"58dd3d5d","908":"fc10c032","987":"287674d2"}[chunkId] + ".chunk.js";
};